import React, { useEffect, useState } from "react";
import "../../../../assets/scss/home.scss";
import "../../../../assets/scss/tests.scss";
import "flatpickr/dist/flatpickr.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Card, CardBody } from "reactstrap";
import Spinner from "../../../../@core/components/spinner/Fallback-spinner";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Row, Col } from "reactstrap";
import { useHistory } from "react-router-dom";
import Repository from "../../../../configs/axios/repository";
import {
    filterAndSplitJsonChoice,
    filterAndSplitJsonWritten,
} from "../../../../utility/helpers/filterJson";
import { handleGetTikets } from "../../../../redux/layout";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import ProgressBar from "@ramonak/react-progress-bar";
import logo from "@src/assets/images/smartStudyLogo.svg";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
const CreateTest = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const locationState = useLocation();
    let notes = locationState.state?.notes;
    let note_id = locationState.state?.note_id;
    let testType = locationState.state?.testType;
    let noteData = locationState.state?.noteData;
    let canDoIt = locationState.state?.canDoIt;
    let showLimit = locationState.state?.showLimit;
    let isDataTest = locationState.state?.isData;
    let courseName = locationState.state?.courseName;
    let course_id = locationState.state?.course_id;
    const [loadingData, setLoadingData] = useState(true);
    const [isData, setIsData] = useState(true);
    const [collCount, setCollCount] = useState(0);
    const role = useSelector((state) => state.layout.role);
    let count = 1;
    let processValue = 10;

    const process = (values) => {
        if (count < 10) {
            setLoadingData(false);
            count = count + 1;
            processValue = processValue + 10;
            setCollCount(processValue);
            hendleNext(values);
        } else {
            setCollCount(100);
            setLoadingData(true);
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "A technical problem occurred while creating the tests, please try again.!",
                confirmButtonText: "Regenerate",
            }).then((result) => {
                if (result.isConfirmed) {
                    processValue = 10;
                    setCollCount(0);
                    hendleNext(values);
                } else {
                    history.push({
                        pathname: "/home",
                    });
                }
            });
        }
    };
    const toaccountingTestPage = async (values, array, modifiedText) => {
        let testData = {
            test_name: noteData.title,
            test_content: "",
            icon: "",
            note_id: {
                note_id: note_id,
            },
            no_of_questions: null,
            test_type: testType,
            test_prompt: modifiedText,
            test_content: JSON.stringify(array),
        };

        dispatch(handleGetTikets(JSON.stringify(testData)));
        if (array) {
            localStorage.setItem("isCreate", true);
            if (role == "instructor") {
                const result = await Repository.postRequest(
                    `api/test/createMultipleChoiceTest`,
                    {
                        ...testData,
                        results: JSON.stringify(array),
                        final_score: null,
                        score: null,
                    }
                );
                if (result.data.success == true) {
                    let test_id = result.data.data.test_id;
                    if (testType == "written") {
                        history.push({
                            pathname: "/resultViewWritten",
                            state: {
                                array,
                                testType,
                                note_id,
                                isData,
                                test_id,
                                noteData,
                                canDoIt,
                                course_id,
                                courseName,
                            },
                        });
                    } else {
                        history.push({
                            pathname: "/resultView",
                            state: {
                                array,
                                testType,
                                note_id,
                                isData,
                                test_id,
                                noteData,
                                canDoIt,
                                course_id,
                                courseName,
                            },
                        });
                    }
                }
            } else {
                localStorage.setItem("isCreateTest", true);
                history.push({
                    pathname: "/accountingTest",
                    state: {
                        array,
                        testType,
                        testData,
                        note_id,
                        isData,
                        noteData,
                        canDoIt,
                    },
                });
            }
        }
    };

    const hendleNext = async (values) => {
        setLoadingData(false);
        let modifiedText = notes.replace(/[^a-zA-Z0-9\s\"\,\.\-\+\/\=\*]/g, "");
        setTimeout(() => {
            setCollCount(processValue);
        }, 1000);
        let data = {
            count: "",
            messages: modifiedText,
            testType: testType,
        };

        const result = await Repository.postRequest(
            `api/test/getChatCompletion`,
            data
        );

        if (result.data.success == false) {
            setLoadingData(false);
        }
        const array =
            testType == "choice"
                ? filterAndSplitJsonChoice(
                      result.data.data.getChatCompletionData
                  )
                : testType == "written"
                ? filterAndSplitJsonWritten(
                      result.data.data.getChatCompletionData
                  )
                : "";

        if (array == "error" || array[0] == undefined) {
            process(values);
        } else {
            setCollCount(100);

            setTimeout(() => {
                toaccountingTestPage(values, array, modifiedText);
            }, 2000);
        }
    };

    useEffect(async () => {
        localStorage.setItem("isCreate", true);
    }, []);

    useEffect(() => {
        if (!isDataTest) {
            hendleNext(notes);
        }
    }, []);

    return loadingData ? (
        <div></div>
    ) : (
        <div className="mt-5">
            <div className="fallback-spinner app-loader progres">
                <img className="fallback-logo" src={logo} alt="logo" />
                <div className="loading loadingDiv">
                    <div className="effect-1 effects"></div>
                    <div className="effect-2 effects"></div>
                    <div className="effect-3 effects"></div>
                </div>
                <ProgressBar completed={collCount} />
            </div>
        </div>
    );
};

export default CreateTest;
